// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2LfsG","inner":"Form_inner__oThey","range":"Form_range__tKrAp","name":"Form_name__1QQDf","actions":"Form_actions__2ql8X"};